import { useState } from 'react'
import toast from 'react-hot-toast'
import Button from './ui/Button'
import Card from './ui/Card'

const FIELD = 'input-field !min-h-[42px] !py-2.5 !px-4 !text-sm'

const PixPaymentPanel = ({ pix, amountLabel, onDone }) => {
  const [copied, setCopied] = useState(false)

  const payload = pix?.payload || ''
  const encodedImage = pix?.encodedImage || ''
  const expirationDate = pix?.expirationDate || null

  const handleCopy = async () => {
    if (!payload) return
    try {
      await navigator.clipboard.writeText(payload)
      setCopied(true)
      toast.success('Código PIX copiado!')
      setTimeout(() => setCopied(false), 2500)
    } catch {
      toast.error('Não foi possível copiar. Selecione o código manualmente.')
    }
  }

  return (
    <Card padding="lg" hover={false} className="border-accent/30">
      <h2 className="text-lg font-extrabold text-gray-900 dark:text-white mb-2">Pague com PIX</h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Escaneie o QR Code ou copie o código abaixo. Valor: <strong>{amountLabel}</strong>
      </p>

      {encodedImage && (
        <div className="flex justify-center mb-4">
          <img
            src={`data:image/png;base64,${encodedImage}`}
            alt="QR Code PIX"
            className="w-48 h-48 sm:w-56 sm:h-56 rounded-xl border border-gray-200 dark:border-gray-700 bg-white p-2"
          />
        </div>
      )}

      {payload && (
        <div className="mb-4">
          <label className="form-label">Pix copia e cola</label>
          <textarea
            readOnly
            value={payload}
            rows={4}
            className={`${FIELD} !text-xs font-mono resize-none`}
          />
          <Button type="button" variant="secondary" size="md" className="w-full mt-2" onClick={handleCopy}>
            {copied ? 'Copiado!' : 'Copiar código PIX'}
          </Button>
        </div>
      )}

      {expirationDate && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
          Validade do QR Code: {new Date(expirationDate).toLocaleString('pt-BR')}
        </p>
      )}

      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Após o pagamento, a confirmação é automática e seu plano será ativado. Você pode acompanhar em Minha conta.
      </p>

      {onDone && (
        <Button type="button" variant="primary" size="lg" className="w-full" onClick={onDone}>
          Ir para Minha conta
        </Button>
      )}
    </Card>
  )
}

export default PixPaymentPanel
